module.exports = __webpack_public_path__ + "img/trill.159d0ea7.jpg";